import { render, staticRenderFns } from "./NotificationsIndexComponent.vue?vue&type=template&id=ba5ff132"
import script from "./NotificationsIndexComponent.vue?vue&type=script&lang=js"
export * from "./NotificationsIndexComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports